import axios from 'axios';
import getCookie from '#/utils/cookies.js';
import { getBaseUrlWithCustomerPrefix } from './serviceCommons';

const BASE_URL = getBaseUrlWithCustomerPrefix(process.env.REACT_APP_URL_API);

export const fetchWidgets = async () => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/widgets/all`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
  });
};

export const fetchActiveWidgets = async () => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/dashboard/dashboards/currentuser`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
  });
};

export const saveWidgets = async dashboard => {
  return await axios({
    method: 'POST',
    url: `${BASE_URL}/core/dashboards/batch/createdashboard`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: dashboard,
  });
};

export const fetchDashBoardSharedModel = async () => {
  return await axios({
    method: 'GET',
    url: `${BASE_URL}/core/dashboards/all`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` }, 
  });
};


export const findDashboardById = (id) => {
  return axios({
    method: 'GET',
    url: `${BASE_URL}/core/widgets/dashboard/${id}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` }, 
  });
};

